import {t, UserFacingCatalogueError} from '../catalogueUi';
import {PricedItemGroupEntryChanged} from './PricedItemGroupEntryChanged';

/**
 * "Review and confirm" could not build one entry of the group from fresh reads. Nothing was sent;
 * the bar names the entry and offers "Remove from group" for it.
 */
export class PricedItemGroupBuildFailure extends UserFacingCatalogueError {
  readonly entryKey: string;

  constructor(entry: {key: string; title: string}, cause: unknown) {
    super(
      cause instanceof PricedItemGroupEntryChanged
        ? t(
            'entity.newVehicle.catalogue.itemGroup.entryChanged',
            '{change} was changed by another author after it was added to the group. Remove it from the group and make the change again.',
            {change: entry.title}
          )
        : t(
            'entity.newVehicle.catalogue.itemGroup.operationFailed',
            '{change} could not be saved. Nothing in the group was saved.',
            {change: entry.title}
          )
    );
    this.name = 'PricedItemGroupBuildFailure';
    this.entryKey = entry.key;
  }
}
